import type { LeadsStats } from "../api/services.types.ts"
import type { LeadKpiTileData } from "../LeadsActivePage/components/kpi/LeadKpiTile.tsx"

/**
 * The stats payload as the row reads it.
 *
 * The endpoint answers in snake_case and the row reads camelCase, so `drill_to`
 * never reached `drillTo` and the API's own drill target — the field the
 * contract defines as what makes a tile clickable — was silently discarded.
 * Reading it here rather than in the row is what lets the server decide which
 * tiles can be drilled: a tile whose population the list cannot express arrives
 * without the key and stays inert, and the client needs no release to follow
 * the server once it can.
 */
export const adoptLeadsStats = (payload: LeadsStats): LeadsStats => ({
  ...payload,
  tiles: (payload?.tiles ?? []).map((tile) => {
    const drillTo =
      tile.drillTo ?? (tile as { drill_to?: string | null }).drill_to
    return drillTo ? ({ ...tile, drillTo } as LeadKpiTileData) : tile
  })
})
